export default {
  header: {
    title: 'Kup kartę podarunkową',
  },
  checkout_btn: {
    title: 'Płatność',
  },
  items: {
    gift_card: {
      online: 'Karta podarunkowa – tylko do użytku online',
      online_and_store: 'Karta podarunkowa (online i w sklepie)',
      title: 'Wybierz żądaną kwotę',
      description: 'Dodaj kartę podarunkową z wybraną ilością do koszyka',
    },
    expiration: {
      label: 'Ważna przez 3 lata',
      title: 'Ciesz się dawaniem!',
      description: 'Odbiorca może elastycznie zrealizować bon w ciągu 3 lat.',
    },
    delivery: {
      label: 'Dostawa natychmiast jako PDF na e-mail',
      title: 'Natychmiastowa dostawa PDF na e-mail',
      description: 'Po bezpiecznej płatności otrzymasz bon natychmiast.',
    },
  },
  form: {
    value: {
      title: 'Wybierz kwotę karty podarunkowej',
      custom: {
        label: 'Własna',
        placeholder: 'Podaj kwotę od {{min}} do {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Ilość',
    },
    email: {
      title: 'Na jaki e-mail wysłać Ci kartę podarunkową?',
      placeholder: 'Twój adres e-mail',
      error: 'Nieprawidłowy e-mail',
    },
  },
  confirmation: {
    title: {
      title: 'Kupić kartę podarunkową?',
      subtitle_one: 'Chcesz kupić 1 kartę podarunkową za {{value}}?',
      subtitle_few: 'Chcesz kupić {{count}} karty podarunkowe za {{value}}?',
      subtitle_many: 'Chcesz kupić {{count}} kart podarunkowych za {{value}}?',
      subtitle_other: 'Chcesz kupić {{count}} karty podarunkowe za {{value}}?',
    },
    description: {
      total: 'Razem:',
      email: 'E-mail:',
      quantity: 'Ilość',
      amount: 'Kwota',
    },
    footer: {
      cancel: 'Anuluj',
      confirm: 'Potwierdź',
    },
  },
};
